import { Sunburst } from "./mark/sunburst";
import { DrillDown } from "./interaction/drillDown";
export function plotlib() {
    return {
        "interaction.drillDown": DrillDown,
        "mark.sunburst": Sunburst,
    };
}
//# sourceMappingURL=lib.js.map